
import Vue from "vue"
import type { PhotoEvent } from "@/types/api/photo"

export default Vue.extend({
  props: {
    event: {
      type: Object as VuePropType<PhotoEvent>,
      required: true,
    },
  },

  computed: {
    coverUrl (): string {
      let banners = [
        this.event.event?.banner?.url,
        this.event.event?.bannerEn?.url,
      ]

      if (this.$i18n.locale !== "ru")
        banners = banners.reverse()

      return this.event.cover?.url ||
        banners.filter(Boolean)[0] ||
        "/img/contact-form-bg.webp"
    },

    date (): string {
      const { date } = this.event
      if (!date) return ""
      return new Intl.DateTimeFormat(this.$i18n.locale, {
        dateStyle: "short",
        timeZone: "UTC",
      }).format(new Date(date))
    },
  },
})
